import { Register } from './Register'

export const RegisterPage = () => {
  return <Register />
}

export default RegisterPage
